export const ALLE_UTTAKSGRAD_AS_NUMBER = [0, 20, 40, 50, 60, 80, 100]
